import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VouchersRoutingModule } from './vouchers-routing.module';
import { VouchersComponent } from './vouchers.component';
import { RouterModule } from '@angular/router';
import { ActiveVoucherComponent } from './active-voucher/active-voucher.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MomentModule } from 'ngx-moment';
import { RedeemedVoucherComponent } from './redeemed-voucher/redeemed-voucher.component';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzFormModule } from 'ng-zorro-antd/form';

@NgModule({
  declarations: [
    VouchersComponent,
    ActiveVoucherComponent,
    RedeemedVoucherComponent
  ],
  imports: [
    CommonModule,
    VouchersRoutingModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MomentModule,

    // ng-zorro modules
    NzButtonModule,
    NzModalModule,
    NzMessageModule,
    NzNotificationModule,
    NzIconModule,
    NzSelectModule,
    NzDropDownModule,
    NzTableModule,
    NzTagModule,
    NzToolTipModule,
    NzPaginationModule,
    NzDatePickerModule,
    NzInputModule,
    NzGridModule,      // <= provides nz-row / nzGutter
    NzLayoutModule,
    NzDrawerModule,
    NzUploadModule,
    NzCardModule,
    NzFormModule
  ]
})
export class VouchersModule { }
